export const TO = 'TO';
export const CC = 'CC';
export const BCC = 'BCC';